/**
 * Ícones dos Acionamentos manuais — réplica fiel dos `JF_ICONS` do protótipo
 * v5.10 (camera / no-signal / bolt / sos). Line-icons 24×24, traço 2, cor do
 * card via `currentColor`; sub-traços fixos: JF yellow (#FECB00) no raio e no
 * "!" do escudo, vermelho (#ef4444) no ✕ do "sem sinal".
 */
import type { CSSProperties, ReactNode } from 'react';

export type QuickActionIconName = 'camera' | 'no-signal' | 'bolt' | 'sos';

const JF_YELLOW = '#FECB00';
const SIGNAL_RED = '#ef4444';

const BODIES: Record<QuickActionIconName, ReactNode> = {
  camera: (
    <>
      <rect x="3" y="7" width="18" height="12" rx="2" />
      <circle cx="12" cy="13" r="3.5" />
      <path d="M8 7l1.5-2h5L16 7" />
    </>
  ),
  'no-signal': (
    <>
      <path d="M4 20h.01M8 20v-3M12 20v-6" />
      <path d="m16 8 5 8M21 8l-5 8" stroke={SIGNAL_RED} />
    </>
  ),
  bolt: <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" stroke={JF_YELLOW} />,
  sos: (
    <>
      <path d="M12 3 4 7v5c0 4.5 3.4 7.9 8 9 4.6-1.1 8-4.5 8-9V7l-8-4Z" />
      <path d="M12 8v4" stroke={JF_YELLOW} />
      <circle cx="12" cy="15.5" r="0.6" fill={JF_YELLOW} stroke={JF_YELLOW} />
    </>
  ),
};

export interface QuickActionIconProps {
  name: QuickActionIconName;
  size?: number;
  /** Cor do traço base (aplicada via `currentColor`). Default: herda do contexto. */
  color?: string;
  className?: string;
}

export function QuickActionIcon({ name, size = 22, color, className }: QuickActionIconProps) {
  const style: CSSProperties = { display: 'inline-block', flexShrink: 0 };
  if (color) style.color = color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
      style={style}
    >
      {BODIES[name]}
    </svg>
  );
}
